var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2763 49C40.5141 49.0002 41.7013 48.5087 42.5766 47.6335C43.452 46.7583 43.9437 45.5712 43.9437 44.3334",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 44.318C7 45.5558 7.49177 46.7429 8.3671 47.6181C9.24243 48.4933 10.4296 48.9849 11.6674 48.9847",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6674 12.0398C10.4296 12.0396 9.24243 12.5312 8.3671 13.4064C7.49177 14.2816 7 15.4687 7 16.7065",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9437 16.7218C43.9437 15.484 43.452 14.2969 42.5766 13.4217C41.7013 12.5466 40.5141 12.055 39.2763 12.0552",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 36.6976V44.3179",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 24.7153V16.7064",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.411 48.9986C32.0486 46.5212 31.0793 43.9085 28.9802 42.4463C26.8811 40.9841 24.0944 40.9805 21.9915 42.4372C19.8887 43.8938 18.9125 46.504 19.5436 48.9831",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2763 49.0001L31.4111 48.9988",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5436 48.9832L11.6674 48.9844",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9437 36.6976V44.3334",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9437 24.7153V16.7218",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9437 24.7153C46.3859 24.1962 48.8989 25.2114 50.2951 27.2814C51.6913 29.3513 51.6913 32.0616 50.2951 34.1316C48.8989 36.2015 46.3859 37.2168 43.9437 36.6976",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6755 12.041L11.6674 12.0397",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2763 12.0551L31.6578 12.0563",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6755 12.0564C19.1564 9.61413 20.1716 7.10121 22.2416 5.705C24.3115 4.30878 27.0218 4.30878 29.0918 5.705C31.1617 7.10121 32.177 9.61413 31.6578 12.0564",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.7153C9.44226 24.1962 11.9552 25.2114 13.3514 27.2814C14.7477 29.3513 14.7477 32.0616 13.3514 34.1316C11.9552 36.2015 9.44226 37.2168 7 36.6976",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleRight);
export default __webpack_public_path__ + "static/media/puzzle-right.becf5077aec8c2efb5dbc68c30b57c1d.svg";
export { ForwardRef as ReactComponent };